import type { RegistryAsset } from '@/shared/api/transcriptor/registryApi';
import { templatesApi } from '@/shared/api/transcriptor/templatesApi';

// A library template becomes the organization's own: a community one is
// imported, an official one cloned. Resolves to the id of the local copy.
export const adoptRegistryAsset = async (
  asset: RegistryAsset,
  organizationId: string,
): Promise<string> => {
  if (asset.originKind === 'community') {
    const { document_template_id } = await templatesApi.importCommunityTemplate(
      asset.id,
      {
        organization_id: organizationId,
      },
    );
    return document_template_id;
  }
  const { local_asset_id } = await templatesApi.cloneDocumentTemplate(
    asset.id,
    { target_organization_id: organizationId },
  );
  return local_asset_id;
};
